import React,{useState,useEffect} from "react";
import LineChart from "../components/LineChart";
import PieChart from "../components/PieChart";
import { getFirestore, collection,getDocs } from "firebase/firestore";
import { app } from "../../Firebase/Firebaseapp";
import PieChartBrand from "../components/PieChartBrand";
import { ToastContainer } from 'react-toastify';





const fireStoreDb = getFirestore(app);

const AdminDashboard = () => {
  const [Totalcar, setTotalcar] = useState([]);
  const [Admins, setAdmins] = useState([]);
  const [TotalCategories, setTotalCategories] = useState([]);
  const [TotalBrands, setTotalBrands] = useState([]);

  const allCars=()=>{
    return getDocs(collection(fireStoreDb,'CarDetails'));
  }

  const allAdmins=()=>{
    return getDocs(collection(fireStoreDb,'AdminUser'));
  }
  const CategoriessData = () => {
    return getDocs(collection(fireStoreDb, 'Categories'));
}
const BrandsData = () => {
  return  getDocs(collection(fireStoreDb, 'Brands'));
}


  useEffect(() => {
    allCars().then((cars)=>setTotalcar(cars.docs));
    allAdmins().then((admin)=>setAdmins(admin.docs));
    BrandsData().then((brands) => setTotalBrands(brands.docs));
    CategoriessData().then((Categoriess) =>setTotalCategories(Categoriess.docs));
   
  }, []);

   
    
    
  




  return (
    
    <div class="grid min-h-[77vh] w-full mb-4 pb-10 px-8 ">
    <ToastContainer />
      <div class="grid grid-cols-12 gap-6">
        <div class="grid grid-cols-12 col-span-12 gap-6 xxl:col-span-9">
          <div class="col-span-12 mt-8">
            <div class="container px-5 py-2 mx-auto">
              <div class="flex flex-col text-center w-full mb-20">
              
                <h1 class="sm:text-3xl text-2xl font-medium title-font text-gray-900">
                  <b className=" text-green-500">Carvely</b> DASHBOARD
                </h1>
              </div>
            </div>
            <div class="grid grid-cols-12 gap-6 mt-5">
              <a
                class="transform  hover:scale-105 transition duration-300 shadow-xl rounded-lg col-span-12 sm:col-span-6 xl:col-span-3 intro-y bg-white"
                href="#"
              >
                <div class="p-5">
                  <div class="flex justify-between">
    
                    <svg class="h-7 w-7 text-blue-400" width="24" viewBox="0 0 24 24">
                  <path d="M20.822 18.096c-3.439-.794-6.64-1.49-5.09-4.418 4.72-8.912 1.251-13.678-3.732-13.678-5.082 0-8.464 4.949-3.732 13.678 1.597 2.945-1.725 3.641-5.09 4.418-3.073.71-3.188 2.236-3.178 4.904l.004 1h23.99l.004-.969c.012-2.688-.092-4.222-3.176-4.935z"/>
                </svg>
                    <div class="bg-green-500 rounded-full h-6 px-2 flex justify-items-center text-white font-semibold text-sm">
                      <span class="flex items-center">30%</span>
                    </div>
                  </div>
                  <div class="ml-2 w-full flex-1">
                    <div>
                      <div class="mt-3 text-3xl font-bold leading-8">{Admins.length}</div>

                      <div class="mt-1 text-base text-gray-600">Total Admins</div>
                    </div>
                  </div>
                </div>
              </a>
              <a
                class="transform  hover:scale-105 transition duration-300 shadow-xl rounded-lg col-span-12 sm:col-span-6 xl:col-span-3 intro-y bg-white"
                href="#"
              >
                <div class="p-5">
                  <div class="flex justify-between">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-7 w-7 text-yellow-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                      />
                    </svg>
                    <div class="bg-red-500 rounded-full h-6 px-2 flex justify-items-center text-white font-semibold text-sm">
                      <span class="flex items-center">30%</span>
                    </div>
                  </div>
                  <div class="ml-2 w-full flex-1">
                    <div>
                      <div class="mt-3 text-3xl font-bold leading-8">{Totalcar.length}</div>

                      <div class="mt-1 text-base text-gray-600">Total Cars</div>
                    </div>
                  </div>
                </div>
              </a>
              <a
                class="transform  hover:scale-105 transition duration-300 shadow-xl rounded-lg col-span-12 sm:col-span-6 xl:col-span-3 intro-y bg-white"
                href="#"
              >
                <div class="p-5">
                  <div class="flex justify-between">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-7 w-7 text-pink-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
                      />
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
                      />
                    </svg>
                    <div class="bg-yellow-500 rounded-full h-6 px-2 flex justify-items-center text-white font-semibold text-sm">
                      <span class="flex items-center">30%</span>
                    </div>
                  </div>
                  <div class="ml-2 w-full flex-1">
                    <div>
                      <div class="mt-3 text-3xl font-bold leading-8">{TotalBrands.length}</div>

                      <div class="mt-1 text-base text-gray-600">Total Brands</div>
                    </div>
                  </div>
                </div>
              </a>
              <a
                class="transform  hover:scale-105 transition duration-300 shadow-xl rounded-lg col-span-12 sm:col-span-6 xl:col-span-3 intro-y bg-white"
                href="#"
              >
                <div class="p-5">
                  <div class="flex justify-between">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-7 w-7 text-green-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
                      />
                    </svg>
                    <div class="bg-blue-500 rounded-full h-6 px-2 flex justify-items-center text-white font-semibold text-sm">
                      <span class="flex items-center">30%</span>
                    </div>
                  </div>
                  <div class="ml-2 w-full flex-1">
                    <div>
                      <div class="mt-3 text-3xl font-bold leading-8">{TotalCategories.length}</div>

                      <div class="mt-1 text-base text-gray-600">Total Categories</div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div className="flex justify-between items-center w-[100%] mt-10 flex-col lg:flex-row">
            <PieChart/>
            <PieChartBrand/>
            <LineChart Admin={Admins.length} Car={Totalcar.length} Brands={TotalBrands.length} Category={TotalCategories.length}/>  
              
            </div>



          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
